import { useTranslation } from 'react-i18next'

import {
  EntityActionTypeSelect,
  getEntityActionTypeSelectOptionsEditOnly,
} from '../../../../Entity'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import {
  FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
  FormikField,
} from '../../../../Formik'
import { REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS } from '../../RequestEditApplicantAddressModal.constants'

function RequestEditApplicantAddressModalActionField() {
  const { t } = useTranslation()

  const actionTypes = getEntityActionTypeSelectOptionsEditOnly()

  return (
    <FormikField
      disabled
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={EntityActionTypeSelect}
      fieldComponentProps={{
        label: t(REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_LABEL_KEYS.action),
      }}
      name={FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME}
      options={actionTypes}
    />
  )
}

export default RequestEditApplicantAddressModalActionField
